import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { handleStartProcessCustomEvent } from 'src/components/EntityPresentation/utils/handleStartProcessCustomEvent';
import { FormioForm } from 'src/components/FormioForm/FormioForm';
import { SpinnerFullWidth } from 'src/components/Spinner/SpinnerFullWidth';
import { Router } from 'src/core/router/Router';
import { SettingsNotificationTemplatesStore } from 'src/stores/SettingsStores/SettingsNotificationTemplatesStore/SettingsNotificationTemplatesStore';
import { SettingsRoutes } from 'src/stores/SettingsStores/SettingsPageStore/ListApplicationSettings';

export const NotificationTemplateList = observer(() => {
    const { url } = useRouteMatch<{ entityId: string }>();

    useEffect(() => {
        store.loadForm(store.itemDetailsFormKey);

        return () => {
            store.formLoader.reset();
        };
    }, []);

    if (store.formLoader.isLoading) {
        return <SpinnerFullWidth />;
    }

    return (
        <div>
            <FormioForm
                key={`${SettingsRoutes.notificationTemplates}-details`}
                form={store.currentItemForm as any}
                onCustomEvent={(event) => {
                    if (
                        event.type === 'startProcess' &&
                        (event.component as any).properties?.processKey
                    ) {
                        handleStartProcessCustomEvent(event, url);
                    }

                    if (event.type === 'edit') {
                        Router.navigate(`${url}/${event.data.id}/edit`);
                    }

                    return Promise.resolve();
                }}
            />
        </div>
    );
});

const store = SettingsNotificationTemplatesStore;
